<template>
  <div class="home-page">
    <Header />
    <main class="main">
      <SideBar />
      <div class="content">
        <keep-alive>
          <router-view :key="key"></router-view>
        </keep-alive>
      </div>
    </main>
  </div>
</template>

<script>
import Header from "@/components/header";
import SideBar from "@/components/sidebar";
export default {
  name: "homePage",
  data() {
    return {};
  },
  components: {
    Header,
    SideBar
  },
  computed: {
    key() {
      return this.$route.fullPath;
    }
  }
};
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  height: 100%;
}
.main {
  width: 100%;
  height: calc(100% - 60px);
  display: flex;

  .content {
    flex: 1;
    height: 100%;
    min-width: calc(100% - 200px);
    padding: 20px;
    box-sizing: border-box;
  }
}
</style>
